import "./settingcard.scss";
import React from "react";

export interface ISettingCard {
    activate: string
    title:string
    body:string
    setActivate: React.Dispatch<React.SetStateAction<string>>
    id: number
}

const SettingCard = ({activate,title,body,setActivate, id}: ISettingCard) => {
    return (
        <div onClick={() => setActivate(`setting${id}`)} className={activate === `setting${id}` ? "Setting-Card activate" : "Setting-Card"}>
            <img
                src={activate === `setting${id}` ? require("../../assets/images/icons/SettingDark.svg").default : require("../../assets/images/icons/SettingLight.svg").default}
                alt="" className="img-fluid"/>
            <div className="Setting-Inside">
                <span className="Setting-Inside-Title">{title}</span>
                <br />
                <span className="Setting-Inside-Body">{body}</span>
            </div>
        </div>
    );
}

export default SettingCard;